module.exports = {"description":"cloud store backend system","username":"please input usename","password":"please input password","login":"Login"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 72